const config = {
  apiKey: "AIzaSyA_7XDmIDexdhQvrSpcnjHGU0o59HiLB_g",
  authDomain: "buymycow.firebaseapp.com",
  databaseURL: "https://buymycow.firebaseio.com",
  projectId: "buymycow",
  storageBucket: "buymycow.appspot.com",
  messagingSenderId: "935442442430"
}

export default config;



// WEBPACK FOOTER //
// ./src/app/config/firebase.js